let elId = 1;

export default function elementId() {
    return "kchart" + elId++;
}
